import request from '@/utils/request'

const chechangReportStatistics = {
  communitySelect(query) {
    return request({
      url: '/chechang/report-statistics/communitySelect',
      method: 'get',
      params: query
    })
  },
  list(query) {
    return request({
      url: '/chechang/report-statistics/list',
      method: 'get',
      params: query
    })
  },
  export(data) {
    return request({
      url: '/chechang/report-statistics/export',
      method: 'post',
      data
    })
  }
}

export default chechangReportStatistics
